import { LoadingButton } from "@mui/lab";
import { Container } from "@mui/material";
import React, { useContext, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import cubeApiClient from "../../BusinessObjects/cubeApiService";
import notify from "devextreme/ui/notify";
import {
  useAppDispatch,
  useAppSelector,
} from "../../BusinessObjects/Redux/app/hook";
import {
  setPushClientUrl,
  setWssUrl,
} from "../../BusinessObjects/Redux/features/app/appSlice";
import { useNavigate } from "react-router-dom";
import { RoutePath } from "../../Utils/RoutePath";
import { UserCompany } from "../../Models/SysConf/UserCompany";
import UserProfile from "../../Models/UserProfile";
import uuid from "react-uuid";
import LoggedContext from "../../BusinessObjects/LoggedContext";
import { login } from "../../BusinessObjects/Redux/features/user/userSlice";
import { RootState } from "../../BusinessObjects/Redux/app/store";

type Props = {};

function LoginGeafPage({}: Props) {
  const loggedContext = useContext(LoggedContext);
  const tokenAPI = useAppSelector((state: RootState) => state.user.tokenAPI);

  const service = new cubeApiClient();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [userName, setUserName] = useState<string>("");
  const [isLoading, setLoading] = useState<boolean>(false);

  const userFake = "GEAF_logincf";
  const fakePass = "Geaf123!";

  // funzione di login, vado inizialmente a chiamare l'endpoint classico per ricevere il token da passare successivamnete alla funzione di login da barcode
  const handleLogin = async () => {
    try {
      setLoading(true);
      // Chiamata di login
      const data = await service.login(userFake, fakePass, false);
      const token = data.access_token;

      // Chiamata di login effettiva per accedere con geaf
      const user = await service.loginGeaf(userName, token);
      const userNameProfile = user.userName;

      const userCompanies: UserCompany[] = user.UserCompanies
        ? JSON.parse(user.UserCompanies)
        : [];

      const userProfile: UserProfile | undefined = user.UserProfile
        ? JSON.parse(user.UserProfile)
        : undefined;

      const myUserCompany: UserCompany | undefined = userCompanies.find(
        (uc: UserCompany) => uc.UserName == userNameProfile
      );

      let sessionId = uuid().replaceAll("-", "");
      let protectionLevel = 0;
      let defOpenPageQuery = "";

      if (myUserCompany) protectionLevel = myUserCompany.ProtectionLevel;
      else if (userProfile) protectionLevel = userProfile.ProtectionLevel;
      else protectionLevel = 0;

      if (myUserCompany) {
        if (myUserCompany.LandingPageMenuItem_ID)
          defOpenPageQuery = "?menu_id=" + myUserCompany.LandingPageMenuItem_ID;
        else if (myUserCompany.LandingPageResource_ID)
          defOpenPageQuery =
            "?resource_id=" + myUserCompany.LandingPageResource_ID;
        else defOpenPageQuery = "";
      }

      let PushServiceUrl = "";

      if (user.access_token !== undefined && userProfile !== undefined) {
        const settings = await service.getSettings(token);

        let tmpPushServiceUrl = settings.PushServiceUrl;
        let tmpWssServiceUrl = settings.WSSUrl;

        // Se non finisce con uno / lo aggiungo
        if (tmpPushServiceUrl[tmpPushServiceUrl.length - 1] != "/")
          tmpPushServiceUrl += "/";

        PushServiceUrl = tmpPushServiceUrl;

        loggedContext.setUserProfile(userProfile);
        loggedContext.setUserToken(userNameProfile, user.access_token);
        loggedContext.setUserPassword(fakePass);

        dispatch(
          login({
            tokenAPI: user.access_token,
            userProfile: userProfile,
            sessionId,
          })
        );

        dispatch(setPushClientUrl(PushServiceUrl));
        dispatch(setWssUrl(tmpWssServiceUrl));

        navigate(RoutePath.HOME + defOpenPageQuery);

        notify("Login effettuato con successo", "success", 3000);
      } else {
        notify("Si è verificato un errore", "error", 3000);
      }
    } catch (err) {
      notify(err, "Si è verificato un errore nell'effettuare il login", 3000);
    } finally {
      setLoading(false);
    }
  };

  // Enter button
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && userName) {
      handleLogin();
    }
  };

  // data binding
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setUserName(e.target.value);

  return (
    <>
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div className="w-100 d-flex row justify-content-center align-items-center mt-5">
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              width: "50%",
              maxWidth: "335px",
            }}
          >
            <LazyLoadImage
              src={`images/e-cube/logo-color.png`}
              alt={"Logo"}
              effect="blur"
              className="img-fluid"
            />
          </div>
        </div>
        <input
          className="col-12 col-md-9 py-3 text-center my-5 input-group-text"
          value={userName}
          placeholder="Pistola il barcode sul badge per entrare"
          onKeyDown={handleKeyDown}
          onChange={handleChange}
          autoFocus
        />

        <LoadingButton
          variant="contained"
          color="primary"
          size="large"
          className="col-12 col-md-9"
          style={{
            marginTop: 32,
            padding: 16,
            fontWeight: "bold",
            borderRadius: 20,
          }}
          onClick={handleLogin}
          loading={isLoading}
          disabled={!userName}
        >
          Accedi
        </LoadingButton>
      </Container>
    </>
  );
}

export default LoginGeafPage;
